import { LoginFormSchemaData } from "../schemas/types";

export const REMEMBER_USER_STORAGE_KEY = "remember_me";

export const eraseRememberedUser = () => {
  localStorage.removeItem(REMEMBER_USER_STORAGE_KEY);
};

export const setRememberedUser = (email: string) => {
  localStorage.setItem(REMEMBER_USER_STORAGE_KEY, email);
};

export const getRememberedUser = () =>
  localStorage.getItem(REMEMBER_USER_STORAGE_KEY);

export const handleRememberUser = (
  data: Omit<LoginFormSchemaData, "password">
) => {
  if (!data.rememberMe) {
    eraseRememberedUser();
    return;
  }

  setRememberedUser(data.email);
};
